import { render, staticRenderFns } from "./ListaAutosInfracao.vue?vue&type=template&id=502da4ca&scoped=true"
import script from "./ListaAutosInfracao.vue?vue&type=script&lang=js"
export * from "./ListaAutosInfracao.vue?vue&type=script&lang=js"
import style0 from "./ListaAutosInfracao.vue?vue&type=style&index=0&id=502da4ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502da4ca",
  null
  
)

export default component.exports